var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const initialState = {
  "bottom-center": [],
  "bottom-left": [],
  "bottom-right": [],
  "top-center": [],
  "top-left": [],
  "top-right": []
};
const notificationsContainerReducer = (state, action) => {
  switch (action.type) {
    case "ADD":
      return addNodeAction(state, action.payload);
    case "REMOVE":
      return removedNodeAction(state, action.payload);
    case "RESET":
      return __spreadValues({}, initialState);
    default:
      throw new Error(
        `Action ${action.type} is not a recognized NotificationsContainer
        action`
      );
  }
};
const addNodeAction = (state, payload) => {
  const { position, method } = payload;
  const container = state[position];
  if (!container) {
    console.warn(
      `You are attempting to access a container ${position} that doesn't exist.`
    );
    return state;
  }
  if (method === "start") {
    return __spreadProps(__spreadValues({}, state), { [position]: [__spreadValues({}, payload), ...container] });
  } else {
    return __spreadProps(__spreadValues({}, state), { [position]: [...container, __spreadValues({}, payload)] });
  }
};
const removedNodeAction = (state, payload) => {
  const { id, position } = payload;
  const container = state[position];
  const nodes = container.filter((item) => item.id !== id);
  return __spreadProps(__spreadValues({}, state), { [position]: nodes });
};

export { initialState, notificationsContainerReducer };
//# sourceMappingURL=bundle.esm4.js.map
